import { render, staticRenderFns } from "./CmgRewardsPromoBanner.vue?vue&type=template&id=2b8f404c&scoped=true&lang=pug"
import script from "./cmg-rewards-promo-banner.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-promo-banner.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardsPromoBanner.vue?vue&type=style&index=0&id=2b8f404c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f404c",
  null
  
)

export default component.exports